module.exports = __webpack_public_path__ + "static/media/zodiacRule.66f4b584.jpg";